/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteTextToSpeechHistoryRequest = {
  ttsId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteTextToSpeechHistoryRequest$inboundSchema: z.ZodType<
  DeleteTextToSpeechHistoryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  tts_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "tts_id": "ttsId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteTextToSpeechHistoryRequest$Outbound = {
  tts_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteTextToSpeechHistoryRequest$outboundSchema: z.ZodType<
  DeleteTextToSpeechHistoryRequest$Outbound,
  z.ZodTypeDef,
  DeleteTextToSpeechHistoryRequest
> = z.object({
  ttsId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    ttsId: "tts_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteTextToSpeechHistoryRequestToJSON(
  deleteTextToSpeechHistoryRequest: DeleteTextToSpeechHistoryRequest,
): string {
  return JSON.stringify(
    DeleteTextToSpeechHistoryRequest$outboundSchema.parse(
      deleteTextToSpeechHistoryRequest,
    ),
  );
}
export function deleteTextToSpeechHistoryRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteTextToSpeechHistoryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteTextToSpeechHistoryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteTextToSpeechHistoryRequest' from JSON`,
  );
}
